import { NgModule } from '@angular/core';
import { IconDirective } from './directives';

@NgModule({
  imports: [IconDirective],
  exports: [IconDirective],
})
export class IconsNgModule {}
